<template>
  <div class="u-box c-modal">
    <!-- header: title (+ optional actions) on the left, close button always top-right -->
    <div class="c-modal-header">
      <div class="c-modal-header__content">
        <slot name="header" />
      </div>
      <button
        v-if="!hideClose"
        type="button"
        class="c-modal-header__close"
        title="Close"
        aria-label="Close"
        @click="requestClose"
      >
        <app-icon name="close" />
      </button>
    </div>

    <!-- body: the only part that scrolls -->
    <div class="c-modal-body">
      <slot name="body" />
    </div>

    <!-- footer: pinned; secondary actions first, primary action last -->
    <div
      v-if="$scopedSlots.footer || $slots.footer"
      class="u-flex-justify-end u-flex-wrap c-modal-footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import AppIcon from '../app-icon/AppIcon';

export default {
  name: 'BaseModalComponent',

  components: {
    AppIcon,
  },

  props: {
    hideClose: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    // Use the modal's own close() when it has one (it may reset state),
    // otherwise emit 'close', which vue-js-modal uses to hide dynamic modals.
    // ✕ does exactly what the modal's own Close/Cancel button does
    requestClose() {
      const modal = this.$parent;

      if (modal && typeof modal.handleClose === 'function') {
        modal.handleClose();
        return;
      }

      if (modal && typeof modal.close === 'function') {
        modal.close();
        return;
      }

      if (modal) {
        modal.$emit('close');
      }
    },
  },
};
</script>
